import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

export const SearchComponent = ({
  _formData,
  setFormData,
  searchRef,
  searchTitle,
}) => {
  const [searchQuery, setSearchQuery] = useState(null);

  let options = [];
  searchRef.map((option) => {
    options.push({
      group: 'Références',
      label: option,
    });
  });
  searchTitle.map((option) => {
    options.push({
      group: 'Titres',
      label: option,
    });
  });

  const handleSearch = async (text) => {
    if (!text || !options.some(({ label }) => label === text)) {
      setSearchQuery(null);
    } else {
      setSearchQuery(text);
    }
  };

  useEffect(() => {
    if (searchRef.includes(searchQuery)) {
      setFormData((state) => ({
        ...state,
        reference: searchQuery,
      }));
    } else if (searchTitle.includes(searchQuery)) {
      setFormData((state) => ({
        ...state,
        name: searchQuery,
      }));
    } else {
      setFormData((state) => ({
        ...state,
        reference: null,
        name: null,
      }));
    }
  }, [searchQuery]);

  return (
    <Box sx={{ minWidth: '80%', display: 'flex', gap: 1 }}>
      <Autocomplete
        autoHighlight
        disablePortal
        options={options}
        groupBy={(option) => option.group}
        getOptionLabel={(option) => option.label}
        onChange={(e, value) => handleSearch(value)}
        sx={{ width: '100%' }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Rechercher un template"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: <>{params.InputProps.endAdornment}</>,
              },
            }}
          />
        )}
      />
      <Button variant="outlined" onClick={() => handleSearch(searchQuery)}>
        <SearchIcon />
      </Button>
    </Box>
  );
};
